import Entity from "./entity";

/**
 * Represents a location or even a position that can place orders.
 *
 * Object representation for a Location document from the database.
 */
class Location extends Entity {
  constructor({
    id,
    restaurantId,
    name,
    isTakeAway,
    isNotified,
    codeId,
    canOrder
  } = {}) {
    super({ id: id, restaurantId: restaurantId });
    this.name = name;
    this.isTakeAway = isTakeAway;
    this.codeId = codeId;
    this.isNotified = isNotified;
    this.canOrder = canOrder;
  }

  /**
   * @returns A plain JS object containing the fields as they will be saved to the
   * database.
   */
  _toMap() {
    return {
      id: this.id,
      name: this.name,
      isNotified: this.isNotified,
      codeId: this.codeId,
      isTakeAway: this.isTakeAway,
      canOrder: this.canOrder
    };
  }

  /**
   * @param {*} snapData `Location` document data as a plain JS object
   * snapshot represented by this `Location`.
   *
   * @returns {Location} A new instance created from the provided map.
   */
  static _fromMap(snapData) {
    return new Location(snapData);
  }

  /**
   * @returns {string} A `string` representation of the collection to which this
   * `Location` belongs to.
   */
  get _functionUrl() {
    return "locations";
  }

  get _collectionName() {
    return `locations`;
  }

  get _entityName() {
    return "location";
  }
}

export default Location;
